import { PenSquare } from "lucide-react";

interface ComposeButtonProps {
  onClick: () => void;
}

export default function ComposeButton({ onClick }: ComposeButtonProps) {
  return (
    <button
      onClick={onClick}
      className="absolute bottom-[max(1.5rem,env(safe-area-inset-bottom))] right-6 z-30 bg-accent hover:bg-accent-hover text-white p-4 transition-colors"
      title="Redactar correo"
    >
      <PenSquare size={22} />
    </button>
  );
}
